import dayjs from 'dayjs';

import { Icon } from 'common/icon';

import { Container } from './styles';
import { CurrentWeekProps } from '../types';

export const CurrentWeek = ({ week }: CurrentWeekProps) => {
  const format = 'MM/DD/YYYY';

  const startDate = week?.startDate
    ? dayjs.unix(week?.startDate).format(format)
    : undefined;
  const endDate = week?.endDate
    ? dayjs.unix(week?.endDate).format(format)
    : undefined;

  const date =
    startDate && endDate ? `${startDate} - ${endDate}` : 'Not selected';

  return (
    <Container>
      <p>{date}</p>
      <Icon icon="calendar" />
    </Container>
  );
};
